import { useRouter } from 'next/router'
import { plainToInstance } from 'class-transformer'

import { Container } from '@components/Container'
import SelectPerPage from '@components/Pagination/components/SelectPerPage/SelectPerPage'
import { StoryCard } from '@components/StoryCard'
import { Pagination } from '@components/Pagination'
import { ArrowLeftIcon } from '@components/icons/ArrowLeftIcon'
import StoryCardSkeleton from '@components/StoryCardSkeleton'
import NoData from '@components/NoData'
import { useDrawer } from '@hooks/contexts/DrawerContext/DrawerContext'
import { StoryDetailReaderType } from '@models/story/StoryDetailReaderType'
import { CampaignPageProps } from './interface'
import { CampaignSearchForm } from './components/CampaignSearchForm'

const perPageOptions = [
  {
    label: '10',
    value: 10,
  },
  {
    label: '20',
    value: 20,
  },
  {
    label: '30',
    value: 30,
  },
]

export function CampaignPage({
  data,
  bannerName,
  page,
  perpage,
  total,
  campaignId,
  initialValues,
  isLoading,
  isLoadingToggleBookLike,
  handleSubmit,
  handlePageChange,
  perpageChange,
  handleLikeBook,
}: CampaignPageProps) {
  const router = useRouter()
  const storyDrawer = useDrawer({ drawer: 'story' })

  return (
    <Container className='mobile:px-[20px] desktop-tablet:pt-[30px] desktop-tablet:pb-[80px]'>
      <div className='flex space-x-[10px]'>
        <button
          onClick={() => router.push('/')}
          className='p-[8px] w-[40px] h-[40px] rounded-full border border-gray-3 desktop:hidden'
        >
          <ArrowLeftIcon
            className='text-secondary dark:text-dark-10'
            width='24'
            height='24'
          />
        </button>
        <h1 className='font-mitr topic-base dark:text-primary'>{bannerName}</h1>
      </div>
      <div className='flex flex-col mt-[20px]'>
        <CampaignSearchForm
          initialValues={initialValues}
          campaignId={campaignId}
          handleSubmit={handleSubmit}
        />
        <hr className='w-full border-t border-gray-3 dark:border-purple mt-[20px]' />
      </div>
      <div
        id='campaign-list'
        className='flex justify-between items-center py-[20px]'
      >
        <div className='text-secondary-1 text-sm font-light'>
          <span className='mobile:hidden'>จำนวนงานเขียน : </span>
          <span className='text-secondary dark:text-dark-10 font-bold px-[5px]'>
            {`${total}`}
          </span>
          รายการ
        </div>

        <SelectPerPage
          value={perpage}
          options={perPageOptions}
          handleSelect={perpageChange}
        />
      </div>
      {isLoading ? (
        <div className='grid grid-cols-2 gap-[20px] mb-[30px] tablet:grid-cols-4'>
          {[...Array(2)].map((l, i) => (
            <StoryCardSkeleton key={i} direction='horizontal' />
          ))}
        </div>
      ) : data.length ? (
        <>
          <div className='grid grid-cols-2 gap-[20px] mb-[30px] tablet:grid-cols-4'>
            {data.map(item => (
              <StoryCard
                key={item.id}
                id={item.id}
                title={item.title}
                isShowBookPromotion={item.hasSalePromotions}
                buyAllChaptersPromotion={item.buyAllChaptersPromotion}
                bookChapterCampaignHeader={item.bookChapterCampaignHeader}
                readFreePromotion={item.readFreePromotion}
                bookBadges={item.bookBadges}
                imageUrl={item.coverResizeImgPath || item.image}
                slug={item.penName.user.profilePageSlug}
                penName={item.penName.firstPenName}
                content={item.content}
                category={item.category.name}
                tags={item.tags}
                chapter={item.chapterCount}
                view={item.viewCount}
                chat={item.commentCount}
                like={item.likeCount}
                isLiked={item.isLiked}
                isEnded={item.isEnded}
                bookType={item.bookType}
                categoryId={item.category.id}
                isToggleBookLike={isLoadingToggleBookLike}
                handleLikeBook={handleLikeBook}
                handleClickStoryCard={() => {
                  storyDrawer.show({
                    bookId: item.id,
                    initialData: plainToInstance(StoryDetailReaderType, {
                      id: item.id,
                      coverImgPath: item.image,
                      title: item.title,
                      writingType: item.writingType,
                      publishedAt: item.publishedAt,
                      cover: item.content,
                      viewCount: item.viewCount,
                      commentCount: item.commentCount,
                      likeCount: item.likeCount,
                      publishedChapterCount: item.chapterCount,
                      penName: item.penName,
                      category: item.category,
                      bookType: item.bookType,
                      tags: item.tags,
                      rating: {
                        name: '',
                      },
                      isEnded: item.isEnded,
                      isEpub: item.isEpub,
                      isPdf: item.isPdf,
                      isLiked: item.isLiked,
                    }),
                  })
                }}
              />
            ))}
          </div>
          <Pagination
            page={page}
            perpage={perpage}
            total={total}
            pageChange={handlePageChange}
          />
        </>
      ) : (
        <NoData />
      )}
    </Container>
  )
}
